import { useState } from 'react';

import { types } from './definitions';
import { range } from './utils';
import { useScroll } from '../';

export const usePagination = <ItemsType>({
  pageSize,
  totalCount,
  items = [],
}: types.UsePaginationProps<ItemsType>): types.UsePaginationResults<ItemsType> => {
  const initialState = {
    currentPage: 1,
    startIndex: 0,
    endIndex: pageSize,
  };
  const [{ currentPage, startIndex, endIndex }, setState] =
    useState(initialState);
  const { scrollTo } = useScroll();
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const pages = range(1, totalPageCount);
  const visibleItems = items.slice(startIndex, endIndex);
  const visibleCount = visibleItems.length;
  const viewingRange = {
    start: startIndex + 1,
    // end should not exceed total number of items (totalCount)
    end: Math.min(endIndex, totalCount),
  };

  const setCurrentPage = ({
    currentPage,
    scrollToTop,
  }: types.SetCurrentPageProps): void => {
    const endIndex = currentPage * pageSize;
    const startIndex = endIndex - pageSize;

    if (scrollToTop) {
      scrollTo({
        top: 0,
        left: 0,
      });
    }

    setState({
      currentPage,
      startIndex,
      endIndex,
    });
  };

  return {
    currentPage,
    pages,
    setCurrentPage,
    totalPageCount,
    visibleCount,
    viewingRange,
    visibleItems,
  };
};
